exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-autocomplete input[data-v-5f6c01d1] {\n  padding-left: 50px !important;\n}", ""]);

// exports
